export class LuggagePerFoldingSeatData{
    colId:number;
    rowId:number;
    value:number;
}